import { cn } from '../../lib/utils';
import { Spinner } from './Spinner';

interface LoadingStateProps {
  message?: string;
  /** 'spinner' shows the animated Loader2 icon; 'skeleton' shows shimmer bars. */
  variant?: 'spinner' | 'skeleton';
  className?: string;
}

export function LoadingState({
  message = 'Loading…',
  variant = 'spinner',
  className,
}: LoadingStateProps) {
  if (variant === 'skeleton') {
    return (
      <div className={cn('flex flex-col gap-3 py-6', className)}>
        <div className="skeleton h-4 w-3/4 rounded" />
        <div className="skeleton h-4 w-1/2 rounded" />
        <div className="skeleton h-4 w-5/6 rounded" />
      </div>
    );
  }

  return (
    <div
      className={cn(
        'flex items-center justify-center gap-2 py-12 text-muted-foreground',
        className,
      )}
    >
      <Spinner size="md" />
      <span className="text-sm">{message}</span>
    </div>
  );
}
